'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var thenable = require('../utils/promise/thenable');
var find = require('lodash/find');

var collectTreatments = function collectTreatments(conditions) {
  // Rollout conditions are supposed to have the entire partitions list, so we find the first one.
  var firstRolloutCondition = find(conditions, function (cond) {
    return cond.conditionType === 'ROLLOUT';
  });
  // Then extract the treatments from the partitions
  return firstRolloutCondition ? firstRolloutCondition.partitions.map(function (v) {
    return v.treatment;
  }) : [];
};

var ObjectToView = function ObjectToView(json) {
  var splitObject = void 0;

  try {
    splitObject = JSON.parse(json);
  } catch (e) {
    return null;
  }

  if (splitObject == null) return null;

  return {
    name: splitObject.name,
    trafficType: splitObject.trafficTypeName || null,
    killed: splitObject.killed,
    changeNumber: splitObject.changeNumber || 0,
    treatments: collectTreatments(splitObject.conditions)
  };
};

var ObjectsToViews = function ObjectsToViews(jsons) {
  var views = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(jsons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var split = _step.value;

      var view = ObjectToView(split);
      if (view != null) views.push(view);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return views;
};

var SplitManagerFactory = function SplitManagerFactory(_splits) {

  return {
    split: function split(splitName) {
      var split = _splits.getSplit(splitName);

      if (thenable(split)) return split.then(function (result) {
        return ObjectToView(result);
      });
      return ObjectToView(split);
    },
    splits: function splits() {
      var currentSplits = _splits.getAll();

      if (thenable(currentSplits)) return currentSplits.then(ObjectsToViews);
      return ObjectsToViews(currentSplits);
    },
    names: function names() {
      return _splits.getKeys();
    }
  };
};

module.exports = SplitManagerFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/manager/index.js
// module id = 690
// module chunks = 10